import formatSizeNames from '../../utils/formatSizeNames';
import { formDataObjToATCObj, formDataToObj } from '../../utils/formData';

/**
 * Adds an event handler to all add to cart buttons that allows us to async add items to the cart
 */
const addToCartBtnInit = async () => {
  const addToCartBtns = document.querySelectorAll('[data-add-to-cart]');

  addToCartBtns.forEach(async(btn: HTMLElement) => {
    btn.addEventListener('click', async e => {
      e.preventDefault();


      const atcBtn = <HTMLButtonElement>e.target;
      atcBtn.classList.add('loading');

      let productPayload = [];

      if (atcBtn.hasAttribute('data-atc-coord')) {
        // If co-ord: only include checked items
        const coordWrapper = atcBtn.closest('.product-detail--co-ord');
        const atcForms = coordWrapper.querySelectorAll('.product-co-ord');

        atcForms.forEach(item => {
          const include = item.querySelector('[data-co-ord-include]') as HTMLInputElement;
          if (!include || !include.checked) return;

          const form = item.querySelector('form');
          if (!form) return;
          // ensure a variant is selected
          const selectedOption = Array.from(form.querySelectorAll('[data-option-select]'))
            .find(option => (option as HTMLInputElement).checked);
          if (!selectedOption) return;
          if (!(form.querySelector('[name="id"]') as HTMLInputElement).value && form.querySelector('[name="fallback_id"]')) {
            form.querySelector('[name="id"]').remove();
            form.querySelector('[name="fallback_id"]').setAttribute('name', 'id');
          }

          const properties = {};
          const formData = new FormData(form);
          const data = formDataToObj(formData)
          const atcObj = formDataObjToATCObj(data)

          if (selectedOption) {
            const activeSize = formatSizeNames((selectedOption as HTMLInputElement).value, null, null, true);

            properties['Size'] = activeSize;
          }

          if (properties) {
            atcObj.properties = properties
          }

          //below logic added to stop an issue with unselected products being added to cart once the form id was automatically populated
          if(Array.from(form.querySelectorAll('[data-option-select]')).length <= 1 || (JSON.stringify(properties) !== '{}' || selectedOption )) {
            productPayload.push(atcObj)
          }
        })

      } else if (atcBtn.hasAttribute('data-atc-subscription-upsell-id')) {
        const productIdDataAttr = atcBtn.getAttribute('data-atc-product-id');
        const sellingPlanDataAttr = atcBtn.getAttribute('data-atc-subscription-upsell-id');

        productPayload.push({ id: parseInt(productIdDataAttr), quantity: 1, properties: {}, sellingPlan: sellingPlanDataAttr });
      } else {
        const properties = {};

        let _esid;
        try {
          _esid = window['EasySizeParametersDebug'].easysize.pageview_id.toString();
        } catch(e) {
          _esid = '-1'
        }

        if ( _esid !== '-1' ) {
          properties['_esid'] = _esid
        }

        const form = atcBtn.closest('form');

        if (!(form.querySelector('[name="id"]') as HTMLInputElement).value && form.querySelector('[name="fallback_id"]')) {
          form.querySelector('[name="id"]').remove();
          form.querySelector('[name="fallback_id"]').setAttribute('name', 'id');
        }

        const formData = new FormData(form);
        const data = formDataToObj(formData)
        const atcObj = formDataObjToATCObj(data)

        const inputProductId = form ? <HTMLInputElement>form.querySelector('[data-input-properties-id]') : null;
        const inputProductImage = form ?  <HTMLInputElement>form.querySelector('[data-input-properties-image]') : null;

        const sellingPlanElements: NodeListOf<HTMLInputElement> = form ? form.querySelectorAll('[name^=selling_plan]') : null;

        if(window['ReChargeWidget'] && window['ReChargeWidget'].getWidgets().length > 0){
          const sellingPlanStates = await window['ReChargeWidget'].getWidgets()[0].state;
          if (sellingPlanElements.length > 0 && sellingPlanStates) {
            sellingPlanElements.forEach((sellingPlanEl: HTMLInputElement) => {
              if(sellingPlanEl.checked || sellingPlanEl.value) {
                atcObj.sellingPlan = sellingPlanStates.sellingPlanId;
              }
            })
          }
        }

        if (inputProductId) {
          properties['_product_id'] = inputProductId.value;
        }
        if (inputProductImage) {
          properties['_product_image'] = inputProductImage.value;
        }

        const selectedOption = Array.from(form.querySelectorAll('[data-option-select]'))
          .find(option => (option as HTMLInputElement).checked);

        if (selectedOption) {
          const activeSize = formatSizeNames((selectedOption as HTMLInputElement).value, null, null, true);

          properties['Size'] = activeSize;
        }

        if (properties) {
          atcObj.properties = properties
        }

        productPayload = [atcObj];
      }

      console.log(productPayload);

      if(productPayload.length > 0){
        window['blubolt'].cart.addToCart(
          productPayload,
          true,
          () => {
            atcBtn.classList.remove('loading');
            atcBtn.classList.add('success');
            setTimeout(() => {
              atcBtn.classList.remove('success');
            }, 3000);
          }
        );
      }

    }, false);
    btn.removeAttribute('data-add-to-cart')
  })
}

export default addToCartBtnInit;
